import React, { useMemo } from 'react';
import CheckboxGroup from '../../../../ReactSharedScripts/components/CheckboxGroup';
import Button from '../../../../ReactSharedScripts/components/Button';
import { isVisibleIndicator } from '../../../../ReactSharedScripts/modules/detailPage/components/KeyIndicators/utils';
import classes from './styles/index.module.scss';

const IndicatorsTooltip = ({ indicators, tempSelectedItems, onTempChange, onApplyButtonClick }) => {
	const checkboxList = useMemo(() => {
		return indicators
			.filter((i) => !i.isRequired && !i.isTemporaryHidden)
			.map(
				(item) => ({
					...item,
					id: item.id,
					label: item.title,
					checked: isVisibleIndicator(item, tempSelectedItems),
				}),
				[],
			);
	}, [indicators, tempSelectedItems]);

	return (
		<div className={classes.tooltip}>
			<CheckboxGroup
				items={checkboxList}
				arrangement='vertically'
				onIndicatorToggle={onTempChange}
			/>
			<Button
				className={classes.applyButton}
				link
				onClick={onApplyButtonClick}
			>
				Apply
			</Button>
		</div>
	);
};

export { IndicatorsTooltip };
